/* Atipiná PDP — Sticky info column INTELIGENTE (v4)
   Se a coluna info é MAIS ALTA que a viewport, ancora o BOTTOM da coluna
   próximo ao bottom da viewport (em vez do top). Assim ao rolar pouquinho
   o frete/trust aparece (estilo Live!).
   
   Se a coluna CABE na viewport, ancora normalmente no top:96px.
   
   Atualiza apenas no load + resize — zero cálculo em scroll, sem glitch.
   2026-05-22 */

(function(){
  var HEADER_OFFSET = 96;
  var BOTTOM_MARGIN = 32;
  var MOBILE_BREAKPOINT = 1024;

  function updateStickyOffset(){
    var info = document.querySelector('.pdp-live__info');
    if (!info) return;

    if (window.innerWidth < MOBILE_BREAKPOINT){
      info.style.top = '';
      return;
    }

    var infoHeight = info.offsetHeight;
    var viewportHeight = window.innerHeight;
    var availableHeight = viewportHeight - HEADER_OFFSET - BOTTOM_MARGIN;

    if (infoHeight <= availableHeight){
      info.style.top = HEADER_OFFSET + 'px';
    } else {
      var negTop = viewportHeight - infoHeight - BOTTOM_MARGIN;
      info.style.top = negTop + 'px';
    }
  }

  function init(){
    updateStickyOffset();
    setTimeout(updateStickyOffset, 100);
    setTimeout(updateStickyOffset, 500);
    setTimeout(updateStickyOffset, 1500);

    var resizeTimer = null;
    window.addEventListener('resize', function(){
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateStickyOffset, 100);
    });

    document.querySelectorAll('.pdp-live__gallery img, .pdp-live__info img').forEach(function(img){
      if (img.complete) return;
      img.addEventListener('load', updateStickyOffset, { once: true });
    });

    var observer = new MutationObserver(function(){
      updateStickyOffset();
    });
    var info = document.querySelector('.pdp-live__info');
    if (info){
      observer.observe(info, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
